import { Button, Grid, Stack } from "@mui/material";
import Link from "src/components/link";
import * as React from "react";
import styled from "styled-components";
import AvatarBadge from "src/components/avatar-badge";
import Tooltip from "@mui/material/Tooltip";
import { useTeams } from "src/scenes/teams/teams-provider";

const ButtonWithBorder = styled(Button)`
    border: 2px solid #ffffff14;
    border-radius: 14px;
    height: 120px;
    width: 280px;
    &:hover {
        border: 3px solid ${({ theme }) => theme.palette.primary.main};
    }
`;

const DashboardSubtitle = styled.p`
    font-size: 12px;
    color: white;
    text-transform: none;
`;

const DashboardName = styled.p`
    font-size: 12px;
    font-weight: 200;
    color: white;
    text-transform: none;
    background-color: #292929;
    border-radius: 8px;
    padding: 2px 8px;
`;

const ViewButton = ({ dashboards, teamId, name }) => {
    if (!dashboards || dashboards.length === 0) return null;
    const [teamData, setTeamData] = React.useState({
        picture: undefined,
    });

    const teamsApi = useTeams();
    React.useEffect(() => {
        if (teamsApi.status === "SUCCESS") {
            const matchingTeam = teamsApi.data.find((team) => team.id === teamId);
            setTeamData(
                matchingTeam || {
                    picture: undefined,
                }
            );
        }
    }, [teamsApi.status]);

    const visibleDashboards = dashboards.slice(0, 3);
    const remainingDashboards = dashboards.slice(3);
    const handleRedirect = () => {
        if (teamId) {
            return `/teams/${teamId}/dashboard/${dashboards[0].urlHandle}`;
        }
        if (dashboards[0].urlHandle === "repo-view") {
            return "/repo-view";
        }
        return `/dashboard/${dashboards[0].urlHandle}`;
    };

    return (
        <Stack alignItems="center">
            <Link to={handleRedirect()} variant="plain">
                <Stack direction="column" alignItems="center">
                    <ButtonWithBorder onClick={() => handleRedirect}>
                        <Stack direction="column" style={{ width: "100%" }}>
                            <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                                style={{ width: "100%" }}
                            >
                                {(name || teamData.picture) && (
                                    <AvatarBadge
                                        name={name}
                                        picture={teamData.picture}
                                        isLoading={!dashboards}
                                    />
                                )}
                                <Stack alignItems="flex-start">
                                    {name}
                                    {/* <DashboardSubtitle style={{ margin: 0 }}> */}
                                    {/*    {name} */}
                                    {/* </DashboardSubtitle> */}
                                </Stack>
                            </Stack>
                            <Grid container spacing={0.5}>
                                {visibleDashboards.map((dashboard) => (
                                    <Grid item key={dashboard.id}>
                                        <Tooltip
                                            title={`Created by: ${
                                                dashboard.createdBy || "Unknown"
                                            }`}
                                            arrow
                                        >
                                            <DashboardName>{dashboard.title}</DashboardName>
                                        </Tooltip>
                                    </Grid>
                                ))}
                                {remainingDashboards.length > 0 && (
                                    <Grid item>
                                        <Tooltip
                                            title={remainingDashboards
                                                .map(
                                                    (d) =>
                                                        `${d.title} (Created by: ${
                                                            d.createdBy || "Unknown"
                                                        })`
                                                )
                                                .join(", ")}
                                            arrow
                                        >
                                            <DashboardSubtitle>•••</DashboardSubtitle>
                                        </Tooltip>
                                    </Grid>
                                )}
                            </Grid>
                        </Stack>
                    </ButtonWithBorder>
                </Stack>
            </Link>
        </Stack>
    );
};
export default ViewButton;
